// extracted by mini-css-extract-plugin
module.exports = {"buttonsWrapper":"categoriesModal_buttonsWrapper__189pV"};